import React from "react";
import { 
  FaFilePdf, 
  FaFileImage, 
  FaFileAlt, 
  FaFileVideo, 
  FaFileAudio, 
  FaFileCsv, 
  FaFileExcel, 
  FaFileWord, 
  FaFileArchive,
  FaFile
} from "react-icons/fa";

const FileIcon = ({ extension, className = "w-8 h-8" }) => {
  const ext = extension?.toLowerCase().replace(".", "");

  switch (ext) {
    case "pdf":
      return <FaFilePdf className={`${className} text-red-500`} />;
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "svg":
      return <FaFileImage className={`${className} text-blue-500`} />;
    case "mp4":
    case "mov":
    case "avi":
      return <FaFileVideo className={`${className} text-purple-500`} />;
    case "mp3":
    case "wav":
      return <FaFileAudio className={`${className} text-pink-500`} />;
    case "csv":
      return <FaFileCsv className={`${className} text-green-600`} />;
    case "xlsx":
    case "xls":
      return <FaFileExcel className={`${className} text-green-700`} />;
    case "doc":
    case "docx":
      return <FaFileWord className={`${className} text-blue-700`} />;
    case "zip":
    case "rar":
    case "7z":
      return <FaFileArchive className={`${className} text-yellow-600`} />;
    case "txt":
      return <FaFileAlt className={`${className} text-gray-500`} />;
    default:
      return <FaFile className={`${className} text-slate-400`} />;
  }
};

export default FileIcon;
